import { useSelector } from 'react-redux';
import { isOpenToolbar as isOpenToolbarSelector } from 'containers/Project/selectors';

export const useIsOpenToolbar = (): boolean => {
  return useSelector(isOpenToolbarSelector);
};
